import { type ReactNode } from 'react';
import { ToastProvider, ToastViewport, Toast, useToastState } from '@tamagui/toast';
import { YStack, XStack, Text, Button } from 'tamagui';

declare module '@tamagui/toast' {
  interface CustomData {
    preset?: 'error' | 'success' | 'info';
  }
}

function CurrentToast() {
  const toast = useToastState();
  if (!toast || toast.isHandledNatively) return null;

  const preset = toast.customData?.preset ?? 'info';
  const themeMap = { error: 'red', success: 'green', info: 'blue' } as const;
  const theme = preset in themeMap ? themeMap[preset as keyof typeof themeMap] : ('blue' as const);

  return (
    <Toast
      key={toast.id}
      duration={toast.duration}
      theme={theme}
      borderRadius="$4"
      paddingHorizontal="$4"
      paddingVertical="$3"
    >
      <XStack alignItems="center" justifyContent="space-between" gap="$2">
        <YStack flex={1}>
          <Toast.Title fontWeight="600">{toast.title}</Toast.Title>
        </YStack>
        <Toast.Action altText="Schließen" asChild>
          <Button size="$2" chromeless>
            <Text>✕</Text>
          </Button>
        </Toast.Action>
      </XStack>
    </Toast>
  );
}

interface AppToastProviderProps {
  children: ReactNode;
}

export function AppToastProvider({ children }: AppToastProviderProps) {
  return (
    <ToastProvider swipeDirection="up">
      {children}
      <CurrentToast />
      <ToastViewport top="$4" left={0} right={0} flexDirection="column" alignItems="center" />
    </ToastProvider>
  );
}
